const initDialogBehavior = (dialog, onOpen = null) => {
	const trigger = document.querySelector(`[aria-controls="${dialog.id}"]`);
	const closeBtn = dialog.querySelector('.app-dialog__close');

	const openDialog = (event) => {
		event?.preventDefault();
		onOpen?.();
		dialog.showModal();
	};

	const handleTriggerKeydown = (event) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			onOpen?.();
			dialog.showModal();
		}
	};

	const handleBackdropClick = (e) => {
		const rect = dialog.getBoundingClientRect();
		const isOutside =
			e.clientX < rect.left ||
			e.clientX > rect.right ||
			e.clientY < rect.top ||
			e.clientY > rect.bottom;
		if (isOutside) dialog.close();
	};

	trigger?.addEventListener('click', openDialog);
	trigger?.addEventListener('keydown', handleTriggerKeydown);
	closeBtn?.addEventListener('click', () => dialog.close());
	dialog.addEventListener('click', handleBackdropClick);
};

export { initDialogBehavior };
